import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  padding: 24px 16px;
  margin: -90px auto 0;
  max-width: 740px;
  width: 100%;
  z-index: 1;
  min-height: 155px;

  & h1,
  h3 {
    text-transform: uppercase;
  }

  & > :last-child {
    margin-top: 36px;
  }

  ${media.sm`
    margin: -200px auto 0;

    & > :last-child {
      margin-top: 54px;
    }
  `}
`;

export const TitleArea = styled.span`
  display: grid;
  grid-template-columns: 1fr 2fr;
  white-space: nowrap;
  column-gap: 25px;
  align-items: center;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.yellow25};
`;
